import createLanguageAsyncLoader from "./create-language-async-loader.js";
export default {
  abap: createLanguageAsyncLoader("abap", function () {
    return import(/* webpackChunkName: "react-syntax-highlighter_languages_refractor_abap" */"refractor/abap");
  }),
  abnf: createLanguageAsyncLoader("abnf", function () {
    return import(/* webpackChunkName: "react-syntax-highlighter_languages_refractor_abnf" */"refractor/abnf");
  }),
  actionscript: createLanguageAsyncLoader("actionscript", function () {
    return import(/* webpackChunkName: "react-syntax-highlighter_languages_refractor_actionscript" */"refractor/actionscript");
  }),
  ada: createLanguageAsyncLoader("ada", function () {
    return import(/* webpackChunkName: "react-syntax-highlighter_languages_refractor_ada" */"refractor/ada");
  }),
  agda: createLanguageAsyncLoader("agda", function () {
    return import(/* webpackChunkName: "react-syntax-highlighter_languages_refractor_agda" */"refractor/agda");
  }),
  al: createLanguageAsyncLoader("al", function () {
    return import(/* webpackChunkName: "react-syntax-highlighter_languages_refractor_al" */"refractor/al");
  }),
  antlr4: createLanguageAsyncLoader("antlr4", function () {
    return import(/* webpackChunkName: "react-syntax-highlighter_languages_refractor_antlr4" */"refractor/antlr4");
  }),
  apacheconf: createLanguageAsyncLoader("apacheconf", function () {
    return import(/* webpackChunkName: "react-syntax-highlighter_languages_refractor_apacheconf" */"refractor/apacheconf");
  }),
  apex: createLanguageAsyncLoader("apex", function () {
    return import(/* webpackChunkName: "react-syntax-highlighter_languages_refractor_apex" */"refractor/apex");
  }),
  apl: createLanguageAsyncLoader("apl", function () {
    return import(/* webpackChunkName: "react-syntax-highlighter_languages_refractor_apl" */"refractor/apl");
  }),
  applescript: createLanguageAsyncLoader("applescript", function () {
    return import(/* webpackChunkName: "react-syntax-highlighter_languages_refractor_applescript" */"refractor/applescript");
  }),
  aql: createLanguageAsyncLoader("aql", function () {
    return import(/* webpackChunkName: "react-syntax-highlighter_languages_refractor_aql" */"refractor/aql");
  }),
  arduino: createLanguageAsyncLoader("arduino", function () {
    return import(/* webpackChunkName: "react-syntax-highlighter_languages_refractor_arduino" */"refractor/arduino");
  }),
  arff: createLanguageAsyncLoader("arff", function () {
    return import(/* webpackChunkName: "react-syntax-highlighter_languages_refractor_arff" */"refractor/arff");
  }),
  armasm: createLanguageAsyncLoader("armasm", function () {
    return import(/* webpackChunkName: "react-syntax-highlighter_languages_refractor_armasm" */"refractor/armasm");
  }),
  arturo: createLanguageAsyncLoader("arturo", function () {
    return import(/* webpackChunkName: "react-syntax-highlighter_languages_refractor_arturo" */"refractor/arturo");
  }),
  asciidoc: createLanguageAsyncLoader("asciidoc", function () {
    return import(/* webpackChunkName: "react-syntax-highlighter_languages_refractor_asciidoc" */"refractor/asciidoc");
  }),
  asm6502: createLanguageAsyncLoader("asm6502", function () {
    return import(/* webpackChunkName: "react-syntax-highlighter_languages_refractor_asm6502" */"refractor/asm6502");
  }),
  asmatmel: createLanguageAsyncLoader("asmatmel", function () {
    return import(/* webpackChunkName: "react-syntax-highlighter_languages_refractor_asmatmel" */"refractor/asmatmel");
  }),
  aspnet: createLanguageAsyncLoader("aspnet", function () {
    return import(/* webpackChunkName: "react-syntax-highlighter_languages_refractor_aspnet" */"refractor/aspnet");
  }),
  autohotkey: createLanguageAsyncLoader("autohotkey", function () {
    return import(/* webpackChunkName: "react-syntax-highlighter_languages_refractor_autohotkey" */"refractor/autohotkey");
  }),
  autoit: createLanguageAsyncLoader("autoit", function () {
    return import(/* webpackChunkName: "react-syntax-highlighter_languages_refractor_autoit" */"refractor/autoit");
  }),
  avisynth: createLanguageAsyncLoader("avisynth", function () {
    return import(/* webpackChunkName: "react-syntax-highlighter_languages_refractor_avisynth" */"refractor/avisynth");
  }),
  avroIdl: createLanguageAsyncLoader("avroIdl", function () {
    return import(/* webpackChunkName: "react-syntax-highlighter_languages_refractor_avroIdl" */"refractor/avro-idl");
  }),
  awk: createLanguageAsyncLoader("awk", function () {
    return import(/* webpackChunkName: "react-syntax-highlighter_languages_refractor_awk" */"refractor/awk");
  }),
  bash: createLanguageAsyncLoader("bash", function () {
    return import(/* webpackChunkName: "react-syntax-highlighter_languages_refractor_bash" */"refractor/bash");
  }),
  basic: createLanguageAsyncLoader("basic", function () {
    return import(/* webpackChunkName: "react-syntax-highlighter_languages_refractor_basic" */"refractor/basic");
  }),
  batch: createLanguageAsyncLoader("batch", function () {
    return import(/* webpackChunkName: "react-syntax-highlighter_languages_refractor_batch" */"refractor/batch");
  }),
  bbcode: createLanguageAsyncLoader("bbcode", function () {
    return import(/* webpackChunkName: "react-syntax-highlighter_languages_refractor_bbcode" */"refractor/bbcode");
  }),
  bbj: createLanguageAsyncLoader("bbj", function () {
    return import(/* webpackChunkName: "react-syntax-highlighter_languages_refractor_bbj" */"refractor/bbj");
  }),
  bicep: createLanguageAsyncLoader("bicep", function () {
    return import(/* webpackChunkName: "react-syntax-highlighter_languages_refractor_bicep" */"refractor/bicep");
  }),
  birb: createLanguageAsyncLoader("birb", function () {
    return import(/* webpackChunkName: "react-syntax-highlighter_languages_refractor_birb" */"refractor/birb");
  }),
  bison: createLanguageAsyncLoader("bison", function () {
    return import(/* webpackChunkName: "react-syntax-highlighter_languages_refractor_bison" */"refractor/bison");
  }),
  bnf: createLanguageAsyncLoader("bnf", function () {
    return import(/* webpackChunkName: "react-syntax-highlighter_languages_refractor_bnf" */"refractor/bnf");
  }),
  bqn: createLanguageAsyncLoader("bqn", function () {
    return import(/* webpackChunkName: "react-syntax-highlighter_languages_refractor_bqn" */"refractor/bqn");
  }),
  brainfuck: createLanguageAsyncLoader("brainfuck", function () {
    return import(/* webpackChunkName: "react-syntax-highlighter_languages_refractor_brainfuck" */"refractor/brainfuck");
  }),
  brightscript: createLanguageAsyncLoader("brightscript", function () {
    return import(/* webpackChunkName: "react-syntax-highlighter_languages_refractor_brightscript" */"refractor/brightscript");
  }),
  bro: createLanguageAsyncLoader("bro", function () {
    return import(/* webpackChunkName: "react-syntax-highlighter_languages_refractor_bro" */"refractor/bro");
  }),
  bsl: createLanguageAsyncLoader("bsl", function () {
    return import(/* webpackChunkName: "react-syntax-highlighter_languages_refractor_bsl" */"refractor/bsl");
  }),
  c: createLanguageAsyncLoader("c", function () {
    return import(/* webpackChunkName: "react-syntax-highlighter_languages_refractor_c" */"refractor/c");
  }),
  cfscript: createLanguageAsyncLoader("cfscript", function () {
    return import(/* webpackChunkName: "react-syntax-highlighter_languages_refractor_cfscript" */"refractor/cfscript");
  }),
  chaiscript: createLanguageAsyncLoader("chaiscript", function () {
    return import(/* webpackChunkName: "react-syntax-highlighter_languages_refractor_chaiscript" */"refractor/chaiscript");
  }),
  cil: createLanguageAsyncLoader("cil", function () {
    return import(/* webpackChunkName: "react-syntax-highlighter_languages_refractor_cil" */"refractor/cil");
  }),
  cilkc: createLanguageAsyncLoader("cilkc", function () {
    return import(/* webpackChunkName: "react-syntax-highlighter_languages_refractor_cilkc" */"refractor/cilkc");
  }),
  cilkcpp: createLanguageAsyncLoader("cilkcpp", function () {
    return import(/* webpackChunkName: "react-syntax-highlighter_languages_refractor_cilkcpp" */"refractor/cilkcpp");
  }),
  clike: createLanguageAsyncLoader("clike", function () {
    return import(/* webpackChunkName: "react-syntax-highlighter_languages_refractor_clike" */"refractor/clike");
  }),
  clojure: createLanguageAsyncLoader("clojure", function () {
    return import(/* webpackChunkName: "react-syntax-highlighter_languages_refractor_clojure" */"refractor/clojure");
  }),
  cmake: createLanguageAsyncLoader("cmake", function () {
    return import(/* webpackChunkName: "react-syntax-highlighter_languages_refractor_cmake" */"refractor/cmake");
  }),
  cobol: createLanguageAsyncLoader("cobol", function () {
    return import(/* webpackChunkName: "react-syntax-highlighter_languages_refractor_cobol" */"refractor/cobol");
  }),
  coffeescript: createLanguageAsyncLoader("coffeescript", function () {
    return import(/* webpackChunkName: "react-syntax-highlighter_languages_refractor_coffeescript" */"refractor/coffeescript");
  }),
  concurnas: createLanguageAsyncLoader("concurnas", function () {
    return import(/* webpackChunkName: "react-syntax-highlighter_languages_refractor_concurnas" */"refractor/concurnas");
  }),
  cooklang: createLanguageAsyncLoader("cooklang", function () {
    return import(/* webpackChunkName: "react-syntax-highlighter_languages_refractor_cooklang" */"refractor/cooklang");
  }),
  coq: createLanguageAsyncLoader("coq", function () {
    return import(/* webpackChunkName: "react-syntax-highlighter_languages_refractor_coq" */"refractor/coq");
  }),
  cpp: createLanguageAsyncLoader("cpp", function () {
    return import(/* webpackChunkName: "react-syntax-highlighter_languages_refractor_cpp" */"refractor/cpp");
  }),
  crystal: createLanguageAsyncLoader("crystal", function () {
    return import(/* webpackChunkName: "react-syntax-highlighter_languages_refractor_crystal" */"refractor/crystal");
  }),
  csharp: createLanguageAsyncLoader("csharp", function () {
    return import(/* webpackChunkName: "react-syntax-highlighter_languages_refractor_csharp" */"refractor/csharp");
  }),
  cshtml: createLanguageAsyncLoader("cshtml", function () {
    return import(/* webpackChunkName: "react-syntax-highlighter_languages_refractor_cshtml" */"refractor/cshtml");
  }),
  csp: createLanguageAsyncLoader("csp", function () {
    return import(/* webpackChunkName: "react-syntax-highlighter_languages_refractor_csp" */"refractor/csp");
  }),
  cssExtras: createLanguageAsyncLoader("cssExtras", function () {
    return import(/* webpackChunkName: "react-syntax-highlighter_languages_refractor_cssExtras" */"refractor/css-extras");
  }),
  css: createLanguageAsyncLoader("css", function () {
    return import(/* webpackChunkName: "react-syntax-highlighter_languages_refractor_css" */"refractor/css");
  }),
  csv: createLanguageAsyncLoader("csv", function () {
    return import(/* webpackChunkName: "react-syntax-highlighter_languages_refractor_csv" */"refractor/csv");
  }),
  cue: createLanguageAsyncLoader("cue", function () {
    return import(/* webpackChunkName: "react-syntax-highlighter_languages_refractor_cue" */"refractor/cue");
  }),
  cypher: createLanguageAsyncLoader("cypher", function () {
    return import(/* webpackChunkName: "react-syntax-highlighter_languages_refractor_cypher" */"refractor/cypher");
  }),
  d: createLanguageAsyncLoader("d", function () {
    return import(/* webpackChunkName: "react-syntax-highlighter_languages_refractor_d" */"refractor/d");
  }),
  dart: createLanguageAsyncLoader("dart", function () {
    return import(/* webpackChunkName: "react-syntax-highlighter_languages_refractor_dart" */"refractor/dart");
  }),
  dataweave: createLanguageAsyncLoader("dataweave", function () {
    return import(/* webpackChunkName: "react-syntax-highlighter_languages_refractor_dataweave" */"refractor/dataweave");
  }),
  dax: createLanguageAsyncLoader("dax", function () {
    return import(/* webpackChunkName: "react-syntax-highlighter_languages_refractor_dax" */"refractor/dax");
  }),
  dhall: createLanguageAsyncLoader("dhall", function () {
    return import(/* webpackChunkName: "react-syntax-highlighter_languages_refractor_dhall" */"refractor/dhall");
  }),
  diff: createLanguageAsyncLoader("diff", function () {
    return import(/* webpackChunkName: "react-syntax-highlighter_languages_refractor_diff" */"refractor/diff");
  }),
  django: createLanguageAsyncLoader("django", function () {
    return import(/* webpackChunkName: "react-syntax-highlighter_languages_refractor_django" */"refractor/django");
  }),
  dnsZoneFile: createLanguageAsyncLoader("dnsZoneFile", function () {
    return import(/* webpackChunkName: "react-syntax-highlighter_languages_refractor_dnsZoneFile" */"refractor/dns-zone-file");
  }),
  docker: createLanguageAsyncLoader("docker", function () {
    return import(/* webpackChunkName: "react-syntax-highlighter_languages_refractor_docker" */"refractor/docker");
  }),
  dot: createLanguageAsyncLoader("dot", function () {
    return import(/* webpackChunkName: "react-syntax-highlighter_languages_refractor_dot" */"refractor/dot");
  }),
  ebnf: createLanguageAsyncLoader("ebnf", function () {
    return import(/* webpackChunkName: "react-syntax-highlighter_languages_refractor_ebnf" */"refractor/ebnf");
  }),
  editorconfig: createLanguageAsyncLoader("editorconfig", function () {
    return import(/* webpackChunkName: "react-syntax-highlighter_languages_refractor_editorconfig" */"refractor/editorconfig");
  }),
  eiffel: createLanguageAsyncLoader("eiffel", function () {
    return import(/* webpackChunkName: "react-syntax-highlighter_languages_refractor_eiffel" */"refractor/eiffel");
  }),
  ejs: createLanguageAsyncLoader("ejs", function () {
    return import(/* webpackChunkName: "react-syntax-highlighter_languages_refractor_ejs" */"refractor/ejs");
  }),
  elixir: createLanguageAsyncLoader("elixir", function () {
    return import(/* webpackChunkName: "react-syntax-highlighter_languages_refractor_elixir" */"refractor/elixir");
  }),
  elm: createLanguageAsyncLoader("elm", function () {
    return import(/* webpackChunkName: "react-syntax-highlighter_languages_refractor_elm" */"refractor/elm");
  }),
  erb: createLanguageAsyncLoader("erb", function () {
    return import(/* webpackChunkName: "react-syntax-highlighter_languages_refractor_erb" */"refractor/erb");
  }),
  erlang: createLanguageAsyncLoader("erlang", function () {
    return import(/* webpackChunkName: "react-syntax-highlighter_languages_refractor_erlang" */"refractor/erlang");
  }),
  etlua: createLanguageAsyncLoader("etlua", function () {
    return import(/* webpackChunkName: "react-syntax-highlighter_languages_refractor_etlua" */"refractor/etlua");
  }),
  excelFormula: createLanguageAsyncLoader("excelFormula", function () {
    return import(/* webpackChunkName: "react-syntax-highlighter_languages_refractor_excelFormula" */"refractor/excel-formula");
  }),
  factor: createLanguageAsyncLoader("factor", function () {
    return import(/* webpackChunkName: "react-syntax-highlighter_languages_refractor_factor" */"refractor/factor");
  }),
  falselang: createLanguageAsyncLoader("falselang", function () {
    return import(/* webpackChunkName: "react-syntax-highlighter_languages_refractor_falselang" */"refractor/false");
  }),
  firestoreSecurityRules: createLanguageAsyncLoader("firestoreSecurityRules", function () {
    return import(/* webpackChunkName: "react-syntax-highlighter_languages_refractor_firestoreSecurityRules" */"refractor/firestore-security-rules");
  }),
  flow: createLanguageAsyncLoader("flow", function () {
    return import(/* webpackChunkName: "react-syntax-highlighter_languages_refractor_flow" */"refractor/flow");
  }),
  fortran: createLanguageAsyncLoader("fortran", function () {
    return import(/* webpackChunkName: "react-syntax-highlighter_languages_refractor_fortran" */"refractor/fortran");
  }),
  fsharp: createLanguageAsyncLoader("fsharp", function () {
    return import(/* webpackChunkName: "react-syntax-highlighter_languages_refractor_fsharp" */"refractor/fsharp");
  }),
  ftl: createLanguageAsyncLoader("ftl", function () {
    return import(/* webpackChunkName: "react-syntax-highlighter_languages_refractor_ftl" */"refractor/ftl");
  }),
  gap: createLanguageAsyncLoader("gap", function () {
    return import(/* webpackChunkName: "react-syntax-highlighter_languages_refractor_gap" */"refractor/gap");
  }),
  gcode: createLanguageAsyncLoader("gcode", function () {
    return import(/* webpackChunkName: "react-syntax-highlighter_languages_refractor_gcode" */"refractor/gcode");
  }),
  gdscript: createLanguageAsyncLoader("gdscript", function () {
    return import(/* webpackChunkName: "react-syntax-highlighter_languages_refractor_gdscript" */"refractor/gdscript");
  }),
  gedcom: createLanguageAsyncLoader("gedcom", function () {
    return import(/* webpackChunkName: "react-syntax-highlighter_languages_refractor_gedcom" */"refractor/gedcom");
  }),
  gettext: createLanguageAsyncLoader("gettext", function () {
    return import(/* webpackChunkName: "react-syntax-highlighter_languages_refractor_gettext" */"refractor/gettext");
  }),
  gherkin: createLanguageAsyncLoader("gherkin", function () {
    return import(/* webpackChunkName: "react-syntax-highlighter_languages_refractor_gherkin" */"refractor/gherkin");
  }),
  git: createLanguageAsyncLoader("git", function () {
    return import(/* webpackChunkName: "react-syntax-highlighter_languages_refractor_git" */"refractor/git");
  }),
  glsl: createLanguageAsyncLoader("glsl", function () {
    return import(/* webpackChunkName: "react-syntax-highlighter_languages_refractor_glsl" */"refractor/glsl");
  }),
  gml: createLanguageAsyncLoader("gml", function () {
    return import(/* webpackChunkName: "react-syntax-highlighter_languages_refractor_gml" */"refractor/gml");
  }),
  gn: createLanguageAsyncLoader("gn", function () {
    return import(/* webpackChunkName: "react-syntax-highlighter_languages_refractor_gn" */"refractor/gn");
  }),
  goModule: createLanguageAsyncLoader("goModule", function () {
    return import(/* webpackChunkName: "react-syntax-highlighter_languages_refractor_goModule" */"refractor/go-module");
  }),
  go: createLanguageAsyncLoader("go", function () {
    return import(/* webpackChunkName: "react-syntax-highlighter_languages_refractor_go" */"refractor/go");
  }),
  gradle: createLanguageAsyncLoader("gradle", function () {
    return import(/* webpackChunkName: "react-syntax-highlighter_languages_refractor_gradle" */"refractor/gradle");
  }),
  graphql: createLanguageAsyncLoader("graphql", function () {
    return import(/* webpackChunkName: "react-syntax-highlighter_languages_refractor_graphql" */"refractor/graphql");
  }),
  groovy: createLanguageAsyncLoader("groovy", function () {
    return import(/* webpackChunkName: "react-syntax-highlighter_languages_refractor_groovy" */"refractor/groovy");
  }),
  haml: createLanguageAsyncLoader("haml", function () {
    return import(/* webpackChunkName: "react-syntax-highlighter_languages_refractor_haml" */"refractor/haml");
  }),
  handlebars: createLanguageAsyncLoader("handlebars", function () {
    return import(/* webpackChunkName: "react-syntax-highlighter_languages_refractor_handlebars" */"refractor/handlebars");
  }),
  haskell: createLanguageAsyncLoader("haskell", function () {
    return import(/* webpackChunkName: "react-syntax-highlighter_languages_refractor_haskell" */"refractor/haskell");
  }),
  haxe: createLanguageAsyncLoader("haxe", function () {
    return import(/* webpackChunkName: "react-syntax-highlighter_languages_refractor_haxe" */"refractor/haxe");
  }),
  hcl: createLanguageAsyncLoader("hcl", function () {
    return import(/* webpackChunkName: "react-syntax-highlighter_languages_refractor_hcl" */"refractor/hcl");
  }),
  hlsl: createLanguageAsyncLoader("hlsl", function () {
    return import(/* webpackChunkName: "react-syntax-highlighter_languages_refractor_hlsl" */"refractor/hlsl");
  }),
  hoon: createLanguageAsyncLoader("hoon", function () {
    return import(/* webpackChunkName: "react-syntax-highlighter_languages_refractor_hoon" */"refractor/hoon");
  }),
  hpkp: createLanguageAsyncLoader("hpkp", function () {
    return import(/* webpackChunkName: "react-syntax-highlighter_languages_refractor_hpkp" */"refractor/hpkp");
  }),
  hsts: createLanguageAsyncLoader("hsts", function () {
    return import(/* webpackChunkName: "react-syntax-highlighter_languages_refractor_hsts" */"refractor/hsts");
  }),
  http: createLanguageAsyncLoader("http", function () {
    return import(/* webpackChunkName: "react-syntax-highlighter_languages_refractor_http" */"refractor/http");
  }),
  ichigojam: createLanguageAsyncLoader("ichigojam", function () {
    return import(/* webpackChunkName: "react-syntax-highlighter_languages_refractor_ichigojam" */"refractor/ichigojam");
  }),
  icon: createLanguageAsyncLoader("icon", function () {
    return import(/* webpackChunkName: "react-syntax-highlighter_languages_refractor_icon" */"refractor/icon");
  }),
  icuMessageFormat: createLanguageAsyncLoader("icuMessageFormat", function () {
    return import(/* webpackChunkName: "react-syntax-highlighter_languages_refractor_icuMessageFormat" */"refractor/icu-message-format");
  }),
  idris: createLanguageAsyncLoader("idris", function () {
    return import(/* webpackChunkName: "react-syntax-highlighter_languages_refractor_idris" */"refractor/idris");
  }),
  iecst: createLanguageAsyncLoader("iecst", function () {
    return import(/* webpackChunkName: "react-syntax-highlighter_languages_refractor_iecst" */"refractor/iecst");
  }),
  ignore: createLanguageAsyncLoader("ignore", function () {
    return import(/* webpackChunkName: "react-syntax-highlighter_languages_refractor_ignore" */"refractor/ignore");
  }),
  inform7: createLanguageAsyncLoader("inform7", function () {
    return import(/* webpackChunkName: "react-syntax-highlighter_languages_refractor_inform7" */"refractor/inform7");
  }),
  ini: createLanguageAsyncLoader("ini", function () {
    return import(/* webpackChunkName: "react-syntax-highlighter_languages_refractor_ini" */"refractor/ini");
  }),
  io: createLanguageAsyncLoader("io", function () {
    return import(/* webpackChunkName: "react-syntax-highlighter_languages_refractor_io" */"refractor/io");
  }),
  j: createLanguageAsyncLoader("j", function () {
    return import(/* webpackChunkName: "react-syntax-highlighter_languages_refractor_j" */"refractor/j");
  }),
  java: createLanguageAsyncLoader("java", function () {
    return import(/* webpackChunkName: "react-syntax-highlighter_languages_refractor_java" */"refractor/java");
  }),
  javadoc: createLanguageAsyncLoader("javadoc", function () {
    return import(/* webpackChunkName: "react-syntax-highlighter_languages_refractor_javadoc" */"refractor/javadoc");
  }),
  javadoclike: createLanguageAsyncLoader("javadoclike", function () {
    return import(/* webpackChunkName: "react-syntax-highlighter_languages_refractor_javadoclike" */"refractor/javadoclike");
  }),
  javascript: createLanguageAsyncLoader("javascript", function () {
    return import(/* webpackChunkName: "react-syntax-highlighter_languages_refractor_javascript" */"refractor/javascript");
  }),
  javastacktrace: createLanguageAsyncLoader("javastacktrace", function () {
    return import(/* webpackChunkName: "react-syntax-highlighter_languages_refractor_javastacktrace" */"refractor/javastacktrace");
  }),
  jexl: createLanguageAsyncLoader("jexl", function () {
    return import(/* webpackChunkName: "react-syntax-highlighter_languages_refractor_jexl" */"refractor/jexl");
  }),
  jolie: createLanguageAsyncLoader("jolie", function () {
    return import(/* webpackChunkName: "react-syntax-highlighter_languages_refractor_jolie" */"refractor/jolie");
  }),
  jq: createLanguageAsyncLoader("jq", function () {
    return import(/* webpackChunkName: "react-syntax-highlighter_languages_refractor_jq" */"refractor/jq");
  }),
  jsExtras: createLanguageAsyncLoader("jsExtras", function () {
    return import(/* webpackChunkName: "react-syntax-highlighter_languages_refractor_jsExtras" */"refractor/js-extras");
  }),
  jsTemplates: createLanguageAsyncLoader("jsTemplates", function () {
    return import(/* webpackChunkName: "react-syntax-highlighter_languages_refractor_jsTemplates" */"refractor/js-templates");
  }),
  jsdoc: createLanguageAsyncLoader("jsdoc", function () {
    return import(/* webpackChunkName: "react-syntax-highlighter_languages_refractor_jsdoc" */"refractor/jsdoc");
  }),
  json: createLanguageAsyncLoader("json", function () {
    return import(/* webpackChunkName: "react-syntax-highlighter_languages_refractor_json" */"refractor/json");
  }),
  json5: createLanguageAsyncLoader("json5", function () {
    return import(/* webpackChunkName: "react-syntax-highlighter_languages_refractor_json5" */"refractor/json5");
  }),
  jsonp: createLanguageAsyncLoader("jsonp", function () {
    return import(/* webpackChunkName: "react-syntax-highlighter_languages_refractor_jsonp" */"refractor/jsonp");
  }),
  jsstacktrace: createLanguageAsyncLoader("jsstacktrace", function () {
    return import(/* webpackChunkName: "react-syntax-highlighter_languages_refractor_jsstacktrace" */"refractor/jsstacktrace");
  }),
  jsx: createLanguageAsyncLoader("jsx", function () {
    return import(/* webpackChunkName: "react-syntax-highlighter_languages_refractor_jsx" */"refractor/jsx");
  }),
  julia: createLanguageAsyncLoader("julia", function () {
    return import(/* webpackChunkName: "react-syntax-highlighter_languages_refractor_julia" */"refractor/julia");
  }),
  keepalived: createLanguageAsyncLoader("keepalived", function () {
    return import(/* webpackChunkName: "react-syntax-highlighter_languages_refractor_keepalived" */"refractor/keepalived");
  }),
  keyman: createLanguageAsyncLoader("keyman", function () {
    return import(/* webpackChunkName: "react-syntax-highlighter_languages_refractor_keyman" */"refractor/keyman");
  }),
  kotlin: createLanguageAsyncLoader("kotlin", function () {
    return import(/* webpackChunkName: "react-syntax-highlighter_languages_refractor_kotlin" */"refractor/kotlin");
  }),
  kumir: createLanguageAsyncLoader("kumir", function () {
    return import(/* webpackChunkName: "react-syntax-highlighter_languages_refractor_kumir" */"refractor/kumir");
  }),
  kusto: createLanguageAsyncLoader("kusto", function () {
    return import(/* webpackChunkName: "react-syntax-highlighter_languages_refractor_kusto" */"refractor/kusto");
  }),
  latex: createLanguageAsyncLoader("latex", function () {
    return import(/* webpackChunkName: "react-syntax-highlighter_languages_refractor_latex" */"refractor/latex");
  }),
  latte: createLanguageAsyncLoader("latte", function () {
    return import(/* webpackChunkName: "react-syntax-highlighter_languages_refractor_latte" */"refractor/latte");
  }),
  less: createLanguageAsyncLoader("less", function () {
    return import(/* webpackChunkName: "react-syntax-highlighter_languages_refractor_less" */"refractor/less");
  }),
  lilypond: createLanguageAsyncLoader("lilypond", function () {
    return import(/* webpackChunkName: "react-syntax-highlighter_languages_refractor_lilypond" */"refractor/lilypond");
  }),
  linkerScript: createLanguageAsyncLoader("linkerScript", function () {
    return import(/* webpackChunkName: "react-syntax-highlighter_languages_refractor_linkerScript" */"refractor/linker-script");
  }),
  liquid: createLanguageAsyncLoader("liquid", function () {
    return import(/* webpackChunkName: "react-syntax-highlighter_languages_refractor_liquid" */"refractor/liquid");
  }),
  lisp: createLanguageAsyncLoader("lisp", function () {
    return import(/* webpackChunkName: "react-syntax-highlighter_languages_refractor_lisp" */"refractor/lisp");
  }),
  livescript: createLanguageAsyncLoader("livescript", function () {
    return import(/* webpackChunkName: "react-syntax-highlighter_languages_refractor_livescript" */"refractor/livescript");
  }),
  llvm: createLanguageAsyncLoader("llvm", function () {
    return import(/* webpackChunkName: "react-syntax-highlighter_languages_refractor_llvm" */"refractor/llvm");
  }),
  log: createLanguageAsyncLoader("log", function () {
    return import(/* webpackChunkName: "react-syntax-highlighter_languages_refractor_log" */"refractor/log");
  }),
  lolcode: createLanguageAsyncLoader("lolcode", function () {
    return import(/* webpackChunkName: "react-syntax-highlighter_languages_refractor_lolcode" */"refractor/lolcode");
  }),
  lua: createLanguageAsyncLoader("lua", function () {
    return import(/* webpackChunkName: "react-syntax-highlighter_languages_refractor_lua" */"refractor/lua");
  }),
  magma: createLanguageAsyncLoader("magma", function () {
    return import(/* webpackChunkName: "react-syntax-highlighter_languages_refractor_magma" */"refractor/magma");
  }),
  makefile: createLanguageAsyncLoader("makefile", function () {
    return import(/* webpackChunkName: "react-syntax-highlighter_languages_refractor_makefile" */"refractor/makefile");
  }),
  markdown: createLanguageAsyncLoader("markdown", function () {
    return import(/* webpackChunkName: "react-syntax-highlighter_languages_refractor_markdown" */"refractor/markdown");
  }),
  markupTemplating: createLanguageAsyncLoader("markupTemplating", function () {
    return import(/* webpackChunkName: "react-syntax-highlighter_languages_refractor_markupTemplating" */"refractor/markup-templating");
  }),
  markup: createLanguageAsyncLoader("markup", function () {
    return import(/* webpackChunkName: "react-syntax-highlighter_languages_refractor_markup" */"refractor/markup");
  }),
  mata: createLanguageAsyncLoader("mata", function () {
    return import(/* webpackChunkName: "react-syntax-highlighter_languages_refractor_mata" */"refractor/mata");
  }),
  matlab: createLanguageAsyncLoader("matlab", function () {
    return import(/* webpackChunkName: "react-syntax-highlighter_languages_refractor_matlab" */"refractor/matlab");
  }),
  maxscript: createLanguageAsyncLoader("maxscript", function () {
    return import(/* webpackChunkName: "react-syntax-highlighter_languages_refractor_maxscript" */"refractor/maxscript");
  }),
  mel: createLanguageAsyncLoader("mel", function () {
    return import(/* webpackChunkName: "react-syntax-highlighter_languages_refractor_mel" */"refractor/mel");
  }),
  mermaid: createLanguageAsyncLoader("mermaid", function () {
    return import(/* webpackChunkName: "react-syntax-highlighter_languages_refractor_mermaid" */"refractor/mermaid");
  }),
  metafont: createLanguageAsyncLoader("metafont", function () {
    return import(/* webpackChunkName: "react-syntax-highlighter_languages_refractor_metafont" */"refractor/metafont");
  }),
  mizar: createLanguageAsyncLoader("mizar", function () {
    return import(/* webpackChunkName: "react-syntax-highlighter_languages_refractor_mizar" */"refractor/mizar");
  }),
  mongodb: createLanguageAsyncLoader("mongodb", function () {
    return import(/* webpackChunkName: "react-syntax-highlighter_languages_refractor_mongodb" */"refractor/mongodb");
  }),
  monkey: createLanguageAsyncLoader("monkey", function () {
    return import(/* webpackChunkName: "react-syntax-highlighter_languages_refractor_monkey" */"refractor/monkey");
  }),
  moonscript: createLanguageAsyncLoader("moonscript", function () {
    return import(/* webpackChunkName: "react-syntax-highlighter_languages_refractor_moonscript" */"refractor/moonscript");
  }),
  n1ql: createLanguageAsyncLoader("n1ql", function () {
    return import(/* webpackChunkName: "react-syntax-highlighter_languages_refractor_n1ql" */"refractor/n1ql");
  }),
  n4js: createLanguageAsyncLoader("n4js", function () {
    return import(/* webpackChunkName: "react-syntax-highlighter_languages_refractor_n4js" */"refractor/n4js");
  }),
  nand2tetrisHdl: createLanguageAsyncLoader("nand2tetrisHdl", function () {
    return import(/* webpackChunkName: "react-syntax-highlighter_languages_refractor_nand2tetrisHdl" */"refractor/nand2tetris-hdl");
  }),
  naniscript: createLanguageAsyncLoader("naniscript", function () {
    return import(/* webpackChunkName: "react-syntax-highlighter_languages_refractor_naniscript" */"refractor/naniscript");
  }),
  nasm: createLanguageAsyncLoader("nasm", function () {
    return import(/* webpackChunkName: "react-syntax-highlighter_languages_refractor_nasm" */"refractor/nasm");
  }),
  neon: createLanguageAsyncLoader("neon", function () {
    return import(/* webpackChunkName: "react-syntax-highlighter_languages_refractor_neon" */"refractor/neon");
  }),
  nevod: createLanguageAsyncLoader("nevod", function () {
    return import(/* webpackChunkName: "react-syntax-highlighter_languages_refractor_nevod" */"refractor/nevod");
  }),
  nginx: createLanguageAsyncLoader("nginx", function () {
    return import(/* webpackChunkName: "react-syntax-highlighter_languages_refractor_nginx" */"refractor/nginx");
  }),
  nim: createLanguageAsyncLoader("nim", function () {
    return import(/* webpackChunkName: "react-syntax-highlighter_languages_refractor_nim" */"refractor/nim");
  }),
  nix: createLanguageAsyncLoader("nix", function () {
    return import(/* webpackChunkName: "react-syntax-highlighter_languages_refractor_nix" */"refractor/nix");
  }),
  nsis: createLanguageAsyncLoader("nsis", function () {
    return import(/* webpackChunkName: "react-syntax-highlighter_languages_refractor_nsis" */"refractor/nsis");
  }),
  objectivec: createLanguageAsyncLoader("objectivec", function () {
    return import(/* webpackChunkName: "react-syntax-highlighter_languages_refractor_objectivec" */"refractor/objectivec");
  }),
  ocaml: createLanguageAsyncLoader("ocaml", function () {
    return import(/* webpackChunkName: "react-syntax-highlighter_languages_refractor_ocaml" */"refractor/ocaml");
  }),
  odin: createLanguageAsyncLoader("odin", function () {
    return import(/* webpackChunkName: "react-syntax-highlighter_languages_refractor_odin" */"refractor/odin");
  }),
  opencl: createLanguageAsyncLoader("opencl", function () {
    return import(/* webpackChunkName: "react-syntax-highlighter_languages_refractor_opencl" */"refractor/opencl");
  }),
  openqasm: createLanguageAsyncLoader("openqasm", function () {
    return import(/* webpackChunkName: "react-syntax-highlighter_languages_refractor_openqasm" */"refractor/openqasm");
  }),
  oz: createLanguageAsyncLoader("oz", function () {
    return import(/* webpackChunkName: "react-syntax-highlighter_languages_refractor_oz" */"refractor/oz");
  }),
  parigp: createLanguageAsyncLoader("parigp", function () {
    return import(/* webpackChunkName: "react-syntax-highlighter_languages_refractor_parigp" */"refractor/parigp");
  }),
  parser: createLanguageAsyncLoader("parser", function () {
    return import(/* webpackChunkName: "react-syntax-highlighter_languages_refractor_parser" */"refractor/parser");
  }),
  pascal: createLanguageAsyncLoader("pascal", function () {
    return import(/* webpackChunkName: "react-syntax-highlighter_languages_refractor_pascal" */"refractor/pascal");
  }),
  pascaligo: createLanguageAsyncLoader("pascaligo", function () {
    return import(/* webpackChunkName: "react-syntax-highlighter_languages_refractor_pascaligo" */"refractor/pascaligo");
  }),
  pcaxis: createLanguageAsyncLoader("pcaxis", function () {
    return import(/* webpackChunkName: "react-syntax-highlighter_languages_refractor_pcaxis" */"refractor/pcaxis");
  }),
  peoplecode: createLanguageAsyncLoader("peoplecode", function () {
    return import(/* webpackChunkName: "react-syntax-highlighter_languages_refractor_peoplecode" */"refractor/peoplecode");
  }),
  perl: createLanguageAsyncLoader("perl", function () {
    return import(/* webpackChunkName: "react-syntax-highlighter_languages_refractor_perl" */"refractor/perl");
  }),
  phpExtras: createLanguageAsyncLoader("phpExtras", function () {
    return import(/* webpackChunkName: "react-syntax-highlighter_languages_refractor_phpExtras" */"refractor/php-extras");
  }),
  php: createLanguageAsyncLoader("php", function () {
    return import(/* webpackChunkName: "react-syntax-highlighter_languages_refractor_php" */"refractor/php");
  }),
  phpdoc: createLanguageAsyncLoader("phpdoc", function () {
    return import(/* webpackChunkName: "react-syntax-highlighter_languages_refractor_phpdoc" */"refractor/phpdoc");
  }),
  plantUml: createLanguageAsyncLoader("plantUml", function () {
    return import(/* webpackChunkName: "react-syntax-highlighter_languages_refractor_plantUml" */"refractor/plant-uml");
  }),
  plsql: createLanguageAsyncLoader("plsql", function () {
    return import(/* webpackChunkName: "react-syntax-highlighter_languages_refractor_plsql" */"refractor/plsql");
  }),
  powerquery: createLanguageAsyncLoader("powerquery", function () {
    return import(/* webpackChunkName: "react-syntax-highlighter_languages_refractor_powerquery" */"refractor/powerquery");
  }),
  powershell: createLanguageAsyncLoader("powershell", function () {
    return import(/* webpackChunkName: "react-syntax-highlighter_languages_refractor_powershell" */"refractor/powershell");
  }),
  processing: createLanguageAsyncLoader("processing", function () {
    return import(/* webpackChunkName: "react-syntax-highlighter_languages_refractor_processing" */"refractor/processing");
  }),
  prolog: createLanguageAsyncLoader("prolog", function () {
    return import(/* webpackChunkName: "react-syntax-highlighter_languages_refractor_prolog" */"refractor/prolog");
  }),
  promql: createLanguageAsyncLoader("promql", function () {
    return import(/* webpackChunkName: "react-syntax-highlighter_languages_refractor_promql" */"refractor/promql");
  }),
  properties: createLanguageAsyncLoader("properties", function () {
    return import(/* webpackChunkName: "react-syntax-highlighter_languages_refractor_properties" */"refractor/properties");
  }),
  protobuf: createLanguageAsyncLoader("protobuf", function () {
    return import(/* webpackChunkName: "react-syntax-highlighter_languages_refractor_protobuf" */"refractor/protobuf");
  }),
  psl: createLanguageAsyncLoader("psl", function () {
    return import(/* webpackChunkName: "react-syntax-highlighter_languages_refractor_psl" */"refractor/psl");
  }),
  pug: createLanguageAsyncLoader("pug", function () {
    return import(/* webpackChunkName: "react-syntax-highlighter_languages_refractor_pug" */"refractor/pug");
  }),
  puppet: createLanguageAsyncLoader("puppet", function () {
    return import(/* webpackChunkName: "react-syntax-highlighter_languages_refractor_puppet" */"refractor/puppet");
  }),
  pure: createLanguageAsyncLoader("pure", function () {
    return import(/* webpackChunkName: "react-syntax-highlighter_languages_refractor_pure" */"refractor/pure");
  }),
  purebasic: createLanguageAsyncLoader("purebasic", function () {
    return import(/* webpackChunkName: "react-syntax-highlighter_languages_refractor_purebasic" */"refractor/purebasic");
  }),
  purescript: createLanguageAsyncLoader("purescript", function () {
    return import(/* webpackChunkName: "react-syntax-highlighter_languages_refractor_purescript" */"refractor/purescript");
  }),
  python: createLanguageAsyncLoader("python", function () {
    return import(/* webpackChunkName: "react-syntax-highlighter_languages_refractor_python" */"refractor/python");
  }),
  q: createLanguageAsyncLoader("q", function () {
    return import(/* webpackChunkName: "react-syntax-highlighter_languages_refractor_q" */"refractor/q");
  }),
  qml: createLanguageAsyncLoader("qml", function () {
    return import(/* webpackChunkName: "react-syntax-highlighter_languages_refractor_qml" */"refractor/qml");
  }),
  qore: createLanguageAsyncLoader("qore", function () {
    return import(/* webpackChunkName: "react-syntax-highlighter_languages_refractor_qore" */"refractor/qore");
  }),
  qsharp: createLanguageAsyncLoader("qsharp", function () {
    return import(/* webpackChunkName: "react-syntax-highlighter_languages_refractor_qsharp" */"refractor/qsharp");
  }),
  r: createLanguageAsyncLoader("r", function () {
    return import(/* webpackChunkName: "react-syntax-highlighter_languages_refractor_r" */"refractor/r");
  }),
  racket: createLanguageAsyncLoader("racket", function () {
    return import(/* webpackChunkName: "react-syntax-highlighter_languages_refractor_racket" */"refractor/racket");
  }),
  reason: createLanguageAsyncLoader("reason", function () {
    return import(/* webpackChunkName: "react-syntax-highlighter_languages_refractor_reason" */"refractor/reason");
  }),
  regex: createLanguageAsyncLoader("regex", function () {
    return import(/* webpackChunkName: "react-syntax-highlighter_languages_refractor_regex" */"refractor/regex");
  }),
  rego: createLanguageAsyncLoader("rego", function () {
    return import(/* webpackChunkName: "react-syntax-highlighter_languages_refractor_rego" */"refractor/rego");
  }),
  renpy: createLanguageAsyncLoader("renpy", function () {
    return import(/* webpackChunkName: "react-syntax-highlighter_languages_refractor_renpy" */"refractor/renpy");
  }),
  rescript: createLanguageAsyncLoader("rescript", function () {
    return import(/* webpackChunkName: "react-syntax-highlighter_languages_refractor_rescript" */"refractor/rescript");
  }),
  rest: createLanguageAsyncLoader("rest", function () {
    return import(/* webpackChunkName: "react-syntax-highlighter_languages_refractor_rest" */"refractor/rest");
  }),
  rip: createLanguageAsyncLoader("rip", function () {
    return import(/* webpackChunkName: "react-syntax-highlighter_languages_refractor_rip" */"refractor/rip");
  }),
  roboconf: createLanguageAsyncLoader("roboconf", function () {
    return import(/* webpackChunkName: "react-syntax-highlighter_languages_refractor_roboconf" */"refractor/roboconf");
  }),
  robotframework: createLanguageAsyncLoader("robotframework", function () {
    return import(/* webpackChunkName: "react-syntax-highlighter_languages_refractor_robotframework" */"refractor/robotframework");
  }),
  ruby: createLanguageAsyncLoader("ruby", function () {
    return import(/* webpackChunkName: "react-syntax-highlighter_languages_refractor_ruby" */"refractor/ruby");
  }),
  rust: createLanguageAsyncLoader("rust", function () {
    return import(/* webpackChunkName: "react-syntax-highlighter_languages_refractor_rust" */"refractor/rust");
  }),
  sas: createLanguageAsyncLoader("sas", function () {
    return import(/* webpackChunkName: "react-syntax-highlighter_languages_refractor_sas" */"refractor/sas");
  }),
  sass: createLanguageAsyncLoader("sass", function () {
    return import(/* webpackChunkName: "react-syntax-highlighter_languages_refractor_sass" */"refractor/sass");
  }),
  scala: createLanguageAsyncLoader("scala", function () {
    return import(/* webpackChunkName: "react-syntax-highlighter_languages_refractor_scala" */"refractor/scala");
  }),
  scheme: createLanguageAsyncLoader("scheme", function () {
    return import(/* webpackChunkName: "react-syntax-highlighter_languages_refractor_scheme" */"refractor/scheme");
  }),
  scss: createLanguageAsyncLoader("scss", function () {
    return import(/* webpackChunkName: "react-syntax-highlighter_languages_refractor_scss" */"refractor/scss");
  }),
  shellSession: createLanguageAsyncLoader("shellSession", function () {
    return import(/* webpackChunkName: "react-syntax-highlighter_languages_refractor_shellSession" */"refractor/shell-session");
  }),
  smali: createLanguageAsyncLoader("smali", function () {
    return import(/* webpackChunkName: "react-syntax-highlighter_languages_refractor_smali" */"refractor/smali");
  }),
  smalltalk: createLanguageAsyncLoader("smalltalk", function () {
    return import(/* webpackChunkName: "react-syntax-highlighter_languages_refractor_smalltalk" */"refractor/smalltalk");
  }),
  smarty: createLanguageAsyncLoader("smarty", function () {
    return import(/* webpackChunkName: "react-syntax-highlighter_languages_refractor_smarty" */"refractor/smarty");
  }),
  sml: createLanguageAsyncLoader("sml", function () {
    return import(/* webpackChunkName: "react-syntax-highlighter_languages_refractor_sml" */"refractor/sml");
  }),
  solidity: createLanguageAsyncLoader("solidity", function () {
    return import(/* webpackChunkName: "react-syntax-highlighter_languages_refractor_solidity" */"refractor/solidity");
  }),
  solutionFile: createLanguageAsyncLoader("solutionFile", function () {
    return import(/* webpackChunkName: "react-syntax-highlighter_languages_refractor_solutionFile" */"refractor/solution-file");
  }),
  soy: createLanguageAsyncLoader("soy", function () {
    return import(/* webpackChunkName: "react-syntax-highlighter_languages_refractor_soy" */"refractor/soy");
  }),
  sparql: createLanguageAsyncLoader("sparql", function () {
    return import(/* webpackChunkName: "react-syntax-highlighter_languages_refractor_sparql" */"refractor/sparql");
  }),
  splunkSpl: createLanguageAsyncLoader("splunkSpl", function () {
    return import(/* webpackChunkName: "react-syntax-highlighter_languages_refractor_splunkSpl" */"refractor/splunk-spl");
  }),
  sqf: createLanguageAsyncLoader("sqf", function () {
    return import(/* webpackChunkName: "react-syntax-highlighter_languages_refractor_sqf" */"refractor/sqf");
  }),
  sql: createLanguageAsyncLoader("sql", function () {
    return import(/* webpackChunkName: "react-syntax-highlighter_languages_refractor_sql" */"refractor/sql");
  }),
  squirrel: createLanguageAsyncLoader("squirrel", function () {
    return import(/* webpackChunkName: "react-syntax-highlighter_languages_refractor_squirrel" */"refractor/squirrel");
  }),
  stan: createLanguageAsyncLoader("stan", function () {
    return import(/* webpackChunkName: "react-syntax-highlighter_languages_refractor_stan" */"refractor/stan");
  }),
  stata: createLanguageAsyncLoader("stata", function () {
    return import(/* webpackChunkName: "react-syntax-highlighter_languages_refractor_stata" */"refractor/stata");
  }),
  stylus: createLanguageAsyncLoader("stylus", function () {
    return import(/* webpackChunkName: "react-syntax-highlighter_languages_refractor_stylus" */"refractor/stylus");
  }),
  supercollider: createLanguageAsyncLoader("supercollider", function () {
    return import(/* webpackChunkName: "react-syntax-highlighter_languages_refractor_supercollider" */"refractor/supercollider");
  }),
  swift: createLanguageAsyncLoader("swift", function () {
    return import(/* webpackChunkName: "react-syntax-highlighter_languages_refractor_swift" */"refractor/swift");
  }),
  systemd: createLanguageAsyncLoader("systemd", function () {
    return import(/* webpackChunkName: "react-syntax-highlighter_languages_refractor_systemd" */"refractor/systemd");
  }),
  t4Cs: createLanguageAsyncLoader("t4Cs", function () {
    return import(/* webpackChunkName: "react-syntax-highlighter_languages_refractor_t4Cs" */"refractor/t4-cs");
  }),
  t4Templating: createLanguageAsyncLoader("t4Templating", function () {
    return import(/* webpackChunkName: "react-syntax-highlighter_languages_refractor_t4Templating" */"refractor/t4-templating");
  }),
  t4Vb: createLanguageAsyncLoader("t4Vb", function () {
    return import(/* webpackChunkName: "react-syntax-highlighter_languages_refractor_t4Vb" */"refractor/t4-vb");
  }),
  tap: createLanguageAsyncLoader("tap", function () {
    return import(/* webpackChunkName: "react-syntax-highlighter_languages_refractor_tap" */"refractor/tap");
  }),
  tcl: createLanguageAsyncLoader("tcl", function () {
    return import(/* webpackChunkName: "react-syntax-highlighter_languages_refractor_tcl" */"refractor/tcl");
  }),
  textile: createLanguageAsyncLoader("textile", function () {
    return import(/* webpackChunkName: "react-syntax-highlighter_languages_refractor_textile" */"refractor/textile");
  }),
  toml: createLanguageAsyncLoader("toml", function () {
    return import(/* webpackChunkName: "react-syntax-highlighter_languages_refractor_toml" */"refractor/toml");
  }),
  tremor: createLanguageAsyncLoader("tremor", function () {
    return import(/* webpackChunkName: "react-syntax-highlighter_languages_refractor_tremor" */"refractor/tremor");
  }),
  tsx: createLanguageAsyncLoader("tsx", function () {
    return import(/* webpackChunkName: "react-syntax-highlighter_languages_refractor_tsx" */"refractor/tsx");
  }),
  tt2: createLanguageAsyncLoader("tt2", function () {
    return import(/* webpackChunkName: "react-syntax-highlighter_languages_refractor_tt2" */"refractor/tt2");
  }),
  turtle: createLanguageAsyncLoader("turtle", function () {
    return import(/* webpackChunkName: "react-syntax-highlighter_languages_refractor_turtle" */"refractor/turtle");
  }),
  twig: createLanguageAsyncLoader("twig", function () {
    return import(/* webpackChunkName: "react-syntax-highlighter_languages_refractor_twig" */"refractor/twig");
  }),
  typescript: createLanguageAsyncLoader("typescript", function () {
    return import(/* webpackChunkName: "react-syntax-highlighter_languages_refractor_typescript" */"refractor/typescript");
  }),
  typoscript: createLanguageAsyncLoader("typoscript", function () {
    return import(/* webpackChunkName: "react-syntax-highlighter_languages_refractor_typoscript" */"refractor/typoscript");
  }),
  unrealscript: createLanguageAsyncLoader("unrealscript", function () {
    return import(/* webpackChunkName: "react-syntax-highlighter_languages_refractor_unrealscript" */"refractor/unrealscript");
  }),
  uorazor: createLanguageAsyncLoader("uorazor", function () {
    return import(/* webpackChunkName: "react-syntax-highlighter_languages_refractor_uorazor" */"refractor/uorazor");
  }),
  uri: createLanguageAsyncLoader("uri", function () {
    return import(/* webpackChunkName: "react-syntax-highlighter_languages_refractor_uri" */"refractor/uri");
  }),
  v: createLanguageAsyncLoader("v", function () {
    return import(/* webpackChunkName: "react-syntax-highlighter_languages_refractor_v" */"refractor/v");
  }),
  vala: createLanguageAsyncLoader("vala", function () {
    return import(/* webpackChunkName: "react-syntax-highlighter_languages_refractor_vala" */"refractor/vala");
  }),
  vbnet: createLanguageAsyncLoader("vbnet", function () {
    return import(/* webpackChunkName: "react-syntax-highlighter_languages_refractor_vbnet" */"refractor/vbnet");
  }),
  velocity: createLanguageAsyncLoader("velocity", function () {
    return import(/* webpackChunkName: "react-syntax-highlighter_languages_refractor_velocity" */"refractor/velocity");
  }),
  verilog: createLanguageAsyncLoader("verilog", function () {
    return import(/* webpackChunkName: "react-syntax-highlighter_languages_refractor_verilog" */"refractor/verilog");
  }),
  vhdl: createLanguageAsyncLoader("vhdl", function () {
    return import(/* webpackChunkName: "react-syntax-highlighter_languages_refractor_vhdl" */"refractor/vhdl");
  }),
  vim: createLanguageAsyncLoader("vim", function () {
    return import(/* webpackChunkName: "react-syntax-highlighter_languages_refractor_vim" */"refractor/vim");
  }),
  visualBasic: createLanguageAsyncLoader("visualBasic", function () {
    return import(/* webpackChunkName: "react-syntax-highlighter_languages_refractor_visualBasic" */"refractor/visual-basic");
  }),
  warpscript: createLanguageAsyncLoader("warpscript", function () {
    return import(/* webpackChunkName: "react-syntax-highlighter_languages_refractor_warpscript" */"refractor/warpscript");
  }),
  wasm: createLanguageAsyncLoader("wasm", function () {
    return import(/* webpackChunkName: "react-syntax-highlighter_languages_refractor_wasm" */"refractor/wasm");
  }),
  webIdl: createLanguageAsyncLoader("webIdl", function () {
    return import(/* webpackChunkName: "react-syntax-highlighter_languages_refractor_webIdl" */"refractor/web-idl");
  }),
  wgsl: createLanguageAsyncLoader("wgsl", function () {
    return import(/* webpackChunkName: "react-syntax-highlighter_languages_refractor_wgsl" */"refractor/wgsl");
  }),
  wiki: createLanguageAsyncLoader("wiki", function () {
    return import(/* webpackChunkName: "react-syntax-highlighter_languages_refractor_wiki" */"refractor/wiki");
  }),
  wolfram: createLanguageAsyncLoader("wolfram", function () {
    return import(/* webpackChunkName: "react-syntax-highlighter_languages_refractor_wolfram" */"refractor/wolfram");
  }),
  wren: createLanguageAsyncLoader("wren", function () {
    return import(/* webpackChunkName: "react-syntax-highlighter_languages_refractor_wren" */"refractor/wren");
  }),
  xeora: createLanguageAsyncLoader("xeora", function () {
    return import(/* webpackChunkName: "react-syntax-highlighter_languages_refractor_xeora" */"refractor/xeora");
  }),
  xmlDoc: createLanguageAsyncLoader("xmlDoc", function () {
    return import(/* webpackChunkName: "react-syntax-highlighter_languages_refractor_xmlDoc" */"refractor/xml-doc");
  }),
  xojo: createLanguageAsyncLoader("xojo", function () {
    return import(/* webpackChunkName: "react-syntax-highlighter_languages_refractor_xojo" */"refractor/xojo");
  }),
  xquery: createLanguageAsyncLoader("xquery", function () {
    return import(/* webpackChunkName: "react-syntax-highlighter_languages_refractor_xquery" */"refractor/xquery");
  }),
  yaml: createLanguageAsyncLoader("yaml", function () {
    return import(/* webpackChunkName: "react-syntax-highlighter_languages_refractor_yaml" */"refractor/yaml");
  }),
  yang: createLanguageAsyncLoader("yang", function () {
    return import(/* webpackChunkName: "react-syntax-highlighter_languages_refractor_yang" */"refractor/yang");
  }),
  zig: createLanguageAsyncLoader("zig", function () {
    return import(/* webpackChunkName: "react-syntax-highlighter_languages_refractor_zig" */"refractor/zig");
  })
};